import { type ReactNode, useEffect, useState } from 'react';
import i18n from '@/lib/i18n';
import { useOrgStore } from '@/shared/stores/orgStore';

interface I18nProviderProps {
  children: ReactNode;
}

export function I18nProvider({ children }: I18nProviderProps) {
  const [isReady, setIsReady] = useState(i18n.isInitialized);
  const locale = useOrgStore((s) => s.settings.locale);

  useEffect(() => {
    if (!i18n.isInitialized) {
      const handleInitialized = () => {
        setIsReady(true);
      };
      i18n.on('initialized', handleInitialized);
      return () => {
        i18n.off('initialized', handleInitialized);
      };
    }
  }, []);

  useEffect(() => {
    if (locale && locale !== i18n.language) {
      void i18n.changeLanguage(locale);
    }
  }, [locale]);

  if (!isReady) {
    return null;
  }

  return <>{children}</>;
}
